import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IUserActivityService = ( createDecorator('IUserActivityService'));
export { IUserActivityService };
